const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";

@ccclass
export default class NetPromptView extends ViewBase {
    @property(cc.Node)
    mainNode: cc.Node = null

    @property(cc.Node)
    reconnectNode: cc.Node = null

    @property(cc.Label)
    loadingProgress: cc.Label = null;

    showTime: number = 0;
    isProgress: boolean = false;

    riseTo80Second: number = 2;//从0增加到80%用时
    riseTo100Second: number = 10;//0增加到100%用时

    refreshProgress(progress: number)
    {
        if(this.loadingProgress != null)
        {
            this.loadingProgress.string = Math.ceil(progress * 100) + "%";
        }
    }

    startProgress()
    {
        this.showTime = 0;
        this.isProgress = true;
    }
    update(dt)
    {
        if(this.isProgress)
        {
            let progress = 0;
            this.showTime = this.showTime + dt;
            //cc.log("this.onShowTime:" + this.showTime)
            if(this.showTime < this.riseTo80Second)
            {
                progress = (this.showTime / this.riseTo80Second * 0.8)
                this.refreshProgress(progress)
            }else if(this.showTime < this.riseTo100Second){
                progress = 0.8 + ((this.showTime - this.riseTo80Second) / (this.riseTo100Second - this.riseTo80Second) * 0.2)
                this.refreshProgress(progress)
                if(Math.ceil(progress*100) == 100)
                {
                    this.isProgress = false;
                }
            }
        }
        
    }
}